export const mockData = {
  features: [
    {
      icon: "shield",
      title: "Safety First",
      description: "Certified pilots & regular maintenance",
    },
    {
      icon: "award",
      title: "Premium Service",
      description: "Luxury experience with modern fleet",
    },
    {
      icon: "users",
      title: "Expert Team",
      description: "Professional & experienced crew",
    },
    {
      icon: "clock",
      title: "Flexible Timing",
      description: "Multiple slots available daily",
    },
  ],

  fleet: [
    {
      name: "Agusta AW109S Grand",
      description:
        "VVIP Configuration with sound proof. A twin-engine luxury helicopter renowned for its exceptional speed, smooth ride, and superior comfort — ideal for VVIP travel, corporate missions, and rapid intercity transfers.",
      image: require("../assets/Augusta139.jpeg"),
      capacity: "5/6 Passengers + 2 Pilot",
      range: "Approx. 350 NM",
      features: "Climate Control, Noise Reduction, Panoramic Views",
    },
    {
      name: "Airbus H125",
      description:
        "A powerful single-engine helicopter celebrated for its outstanding performance at high altitudes, versatility - ideal for aerial work, charter missions, sightseeing, and remote-area operations.",
      image: require("../assets/UDY-HighKraft.jpeg"),
      capacity: "5 Passengers + 1 Pilot",
      range: "Approx. 340 NM",
      features:
        "Spacious Cabin, Large Windows, High-Altitude Capability, Low Vibration Ride",
    },
    {
      name: "Airbus H130",
      description:
        "A spacious, single-engine helicopter designed for superior passenger comfort and exceptional visibility — perfect for sightseeing tours, VIP transport, and medical or utility missions.",
      image: require("../assets/AirBus130.jpeg"),
      capacity: "6 Passengers + 1 Pilot",
      range: "Approx. 345 NM",
      features:
        "Extra-Wide Cabin, Low Noise Fenestron Tail Rotor, Panoramic Windows, Climate Control",
    },
    {
      name: "Bell 429",
      description:
        "A twin-engine light helicopter known for its exceptional safety, advanced avionics, and smooth ride — ideal for VIP transport, corporate travel, EMS, and law-enforcement missions.",
      image: require("../assets/bell429.jpeg"),
      capacity: "5 Passengers + 2 Pilot",
      range: "Approx. 400–410 NM",
      features:
        "Spacious Flat-Floor Cabin, Advanced Glass Cockpit, Excellent Range and Speed, Low Vibration Ride",
    },
    {
      name: "King Air B250",
      description:
        "A versatile twin-turboprop aircraft offering an exceptional combination of comfort, range, and efficiency — ideal for corporate travel, medical missions, and regional charter flights with short-runway capability.",
      image: require("../assets/Beechcraft-King-Air-360.jpeg"),
      capacity: "8 Passengers + 2 Crew",
      range: "Approx. 1,720 NM",
      features:
        "Spacious Pressurized Cabin, Quiet Ride, Advanced Avionics, Excellent Short-Field Performance",
    },
    {
      name: "Hawker Premier 1A",
      description:
        "A light business jet that delivers jet-class speed with exceptional cabin comfort, featuring one of the largest cabins in its class — perfect for executive travel, quick regional hops, and premium private charters.",
      image: require("../assets/Premier-1-640w.jpeg"),
      capacity: "6 Passengers + 2 Crew",
      range: "Approx. 1,400 NM",
      features:
        "Spacious Stand-Up Cabin Feel, Fast Cruise Speed, Advanced Avionics, Private Club-Style Seating",
    },
    {
      name: "Bombardier Learjet 45 XR",
      description:
        "A high-speed light business jet known for its excellent performance, long-range capability, and superior climb rate — perfect for time-critical business travel and premium private charters.",
      image: require("../assets/Lear45XR-ext-JS.jpg"),
      capacity: "8 Passengers + 2 Crew",
      range: "Approx. 2,000 NM",
      features:
        "Flat-Floor Cabin, Double Club Seating, Fast Cruise Speed, Advanced Avionics Suite",
    },
    {
      name: "Gulfstream G150",
      description:
        "A high-performance mid-size business jet offering impressive range, exceptional speed, and superior cabin comfort — ideal for non-stop regional and international corporate travel with premium privacy and convenience.",
      image: require("../assets/G150-exterior-JS.jpg"),
      capacity: "6–8 Passengers + 2 Crew",
      range: "Approx. 3,000 NM",
      features:
        "Stand-Up Cabin Height, Spacious Club Seating, High-Speed Cruise, Advanced Avionics",
    },
    {
      name: "Beechcraft Hawker 900XP",
      description:
        "A popular mid-size business jet combining long-range capability, excellent fuel efficiency, and outstanding cabin comfort — ideal for corporate travel and private charters across regional and international routes.",
      image: require("../assets/Hawker-900XP.jpg"),
      capacity: "8 Passengers + 2 Crew",
      range: "Approx. 2,800 NM",
      features:
        "Spacious Stand-Up Cabin, Exceptional Range, Enhanced Performance Engines, Advanced Avionics",
    },
    {
      name: "Gulfstream G200",
      description:
        "A spacious super-midsize business jet offering long-range capability, high cruise speed, and exceptional cabin comfort — ideal for nonstop corporate and VIP travel across regional and international routes.",
      image: require("../assets/gulfstream-g200-exterior-1200x628.jpg"),
      capacity: "8–10 Passengers + 2 Crew",
      range: "Approx. 3,400 NM",
      features:
        "Wide Stand-Up Cabin, Generous Baggage Capacity, Club Seating Configuration, Advanced Avionics",
    },
    {
      name: "Dassault Falcon 2000",
      description:
        "A premium super-midsize business jet offering outstanding range, excellent fuel efficiency, and a spacious stand-up cabin — ideal for long-distance corporate and VIP travel with exceptional comfort and reliability.",
      image: require("../assets/Falcon2000_0013_ext_ss_-3-JS.jpg"),
      capacity: "8–10 Passengers + 2 Crew",
      range: "Approx. 3,000–3,500 NM",
      features:
        "Wide Cabin, Long-Range Capability, Quiet Interior, Advanced Avionics, Large Baggage",
    },
    {
      name: "Embraer Legacy 650",
      description:
        "A long-range large-cabin business jet offering exceptional comfort, intercontinental range, and outstanding reliability — ideal for VIP and corporate travel on long nonstop routes with premium in-flight experience.",
      image: require("../assets/Legacy-650-ext-JS.jpg"),
      capacity: "13 Passengers + 2 Crew",
      range: "Approx. 3,900 NM",
      features:
        "Three-Zone Spacious Cabin, Full Galley, Large Baggage Capacity, Low Cabin Altitude, Advanced Avionics",
    },
  ],

  joyRideFeatures: [
    {
      icon: "plane",
      title: "Modern Aircraft",
      description:
        "Our fleet features state-of-the-art helicopters equipped with the latest technology and safety features for your comfort and peace of mind.",
    },
    {
      icon: "navigation",
      title: "Scenic Routes",
      description:
        "Experience breathtaking aerial views of Bangalore's landmarks, including Cubbon Park, Vidhana Soudha, and beautiful lakes from above.",
    },
    {
      icon: "sparkles",
      title: "Memorable Experience",
      description:
        "Create unforgettable memories with friends, family, or that special someone. Perfect for proposals, anniversaries, or celebrations.",
    },
    {
      icon: "users",
      title: "Group Packages",
      description:
        "Customized packages available for families, corporate teams, and special events. Make your occasion truly special with an aerial adventure.",
    },
    {
      icon: "clock",
      title: "Flexible Duration",
      description:
        "Choose from various flight durations to suit your schedule and budget. From quick 10-minute joyrides to extended 30-minute tours.",
    },
    {
      icon: "heart",
      title: "Special Occasions",
      description:
        "Make birthdays, anniversaries, and proposals extra special. Our team can help plan surprise elements to make your day perfect.",
    },
  ],

  safetyCertifications: [
    {
      title: "DGCA Certified Pilots",
      description:
        "All our pilots are certified by the Directorate General of Civil Aviation (DGCA) with extensive flying experience and regular training.",
    },
    {
      title: "Regular Maintenance",
      description:
        "Our aircraft undergo rigorous maintenance checks following international aviation standards to ensure optimal performance and safety.",
    },
    {
      title: "Safety Briefings",
      description:
        "Comprehensive pre-flight safety briefings for all passengers covering emergency procedures and safety protocols.",
    },
    {
      title: "Weather Monitoring",
      description:
        "Advanced weather monitoring systems ensure flights operate only in safe conditions. Your safety is never compromised.",
    },
    {
      title: "Insurance Coverage",
      description:
        "Comprehensive insurance coverage for all passengers and crew, providing complete peace of mind during your flight.",
    },
    {
      title: "Emergency Protocols",
      description:
        "Well-defined emergency response procedures and trained crew to handle any situation with professionalism and efficiency.",
    },
  ],

  galleryImages: [
    "https://images.unsplash.com/photo-1563561686990-f0ef5b3e0b7c",
    "https://images.unsplash.com/photo-1557818673-effec50525e1",
    "https://images.pexels.com/photos/1686990/pexels-photo-1686990.jpeg",
    "https://images.unsplash.com/photo-1476385822777-70eabacbd41f",
    "https://images.unsplash.com/photo-1465447142348-e9952c393450",
    "https://images.pexels.com/photos/931018/pexels-photo-931018.jpeg",
    "https://images.unsplash.com/photo-1496568816309-51d7c20e3b21",
    "https://images.pexels.com/photos/466685/pexels-photo-466685.jpeg",
  ],

  testimonials: [
    {
      name: "Naveen “Nraja” Raja",
      location: "Bangalore",
      comment:
        "A Truly professional team managing and handling ground operations. A quick helicopter ride for all your needs is made so convenient and well organized. Safety considerations was at peak at all times and the pilots are well experienced and truly remarkable with their skills. Top class client handling standards, safety and regulations abiding, safe and well maintained helicopters, easy to reach access point at the heart of Bangalore city...what more can you ask for. 4 thumbs up to the entire team for making this happen. Most recommended!!",
    },
    {
      name: "Neethu Shaju",
      location: "Bangalore",
      comment:
        "First of all let me thank Highcraft Aviation for making our Helicopter ride a wonderful and memorable one. Ever since we got in touch with you, we could see your commitment in organising everything so flawless.Highly recommend Highcraft Aviation for stress free travel experience.",
    },
    {
      name: "Tabreaz Pasha",
      location: "Bangalore",
      comment:
        "What a beautiful experience! Our family enjoyed every moment of the helicopter ride. The professionalism, safety, and warmth shown by the ground and the crew were outstanding. We also celebrated a small event near the venue, making the day even more special. Thank you Highkraft for creating such joyful memories!",
    },
    {
      name: "Nafeesa Sulthana N S",
      location: "Bangalore",
      comment:
        "I recently went for a 10 min helicopter joy ride and absolutely loved it! The staff was helpful and made me feel safe throughout the process. The takeoff was smooth and the aerial views were breathtaking. It was exciting and memorable. Definitely recommended anyone who wants a quick but unforgettable experience!",
    },
    {
      name: "Ashwathi AK",
      location: "Bangalore",
      comment:
        "It was amazing ride and had a best experience. I really enjoyed the adventure a lot.",
    },
    {
      name: "Fyzur Rahaman",
      location: "Bangalore",
      comment:
        "I had a wonderful experience with HighKraft Aviation! The helicopter joy ride was perfectly organized, and the entire team made sure we felt safe and comfortable. From the briefing to the actual flight, everything was handled professionally. The views were breathtaking and the ride felt like a once-in-a-lifetime moment. Thank you HighKraft Aviation for creating such a memorable experience. Definitely recommended!",
    },
  ],
  faqs: [
    {
      question: "What services do you offer?",
      answer:
        "We provide a wide range of helicopter and aircraft charter services including VIP charters, business travel, airport transfers, pilgrimage trips, aerial surveys, corporate movements, and customized charter solutions based on your requirements.",
    },
    {
      question: "How many passengers can be accommodated per flight?",
      answer:
        "Passenger capacity depends on the aircraft type. Helicopters typically accommodate 2–6 passengers, while aircraft capacity varies by model. Our team will suggest the right aircraft based on your group size and luggage.",
    },
    {
      question: "How is the cost of a charter calculated?",
      answer:
        "Charter cost depends on several factors such as aircraft type, total flight time, route, waiting time, crew availability, airport/helipad charges, and government taxes. A detailed quotation is shared before confirmation.",
    },
    {
      question: "Is there any baggage limitation?",
      answer:
        "Yes. Weight and baggage limits depend on aircraft type and safety regulations. Soft bags are preferred. Our team will guide you on permissible luggage once we know the number of passengers and route.",
    },
    {
      question: "What documents are required to fly?",
      answer:
        "All passengers must carry valid government-issued photo ID. For certain locations, special permits may be required, which our operations team will assist with.",
    },
    {
      question: "What happens if the weather is not suitable for flying?",
      answer:
        "Flight operations are strictly weather dependent. If conditions are unsafe, flights may be delayed or rescheduled. Safety is our highest priority and decisions are made in accordance with aviation regulations.",
    },
    {
      question: "How far in advance should I book a charter?",
      answer:
        "Earlier bookings help us secure permissions and aircraft availability. However, we also support urgent or same-day requirements depending on aircraft and regulatory clearance.",
    },
    {
      question: "Are children and elderly passengers allowed?",
      answer:
        "Yes, charter flights are suitable for all age groups, subject to medical fitness and safety regulations. Any special assistance requirements can be arranged in advance.",
    },
    {
      question: "Can flights operate to any location?",
      answer:
        "Flights can operate only to approved airports and helipads. Some destinations require prior government permissions, which our team will guide you through.",
    },
    {
      question: "Is photography allowed during flights?",
      answer:
        "Photography is generally permitted unless restricted by local regulations or security agencies. Your pilot or crew will brief you before the flight.",
    },
    {
      question: "What safety standards do you follow?",
      answer:
        "All operations adhere to DGCA/aviation authority regulations, certified aircraft maintenance practices, experienced licensed pilots, and strict safety protocols.",
    },
    {
      question: "What is your cancellation or rescheduling policy?",
      answer:
        "Cancellation and rescheduling terms vary depending on aircraft type and notice period. These details are clearly mentioned in the quotation and booking confirmation.",
    },
  ],
};
